import React from 'react';
import Form from 'react-bootstrap/Form';
import Stack from 'react-bootstrap/Stack';
import Table from 'react-bootstrap/Table';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import { InfoCircle } from 'react-bootstrap-icons';
import { depths as cols, perDepthValues as rows } from 'engine';
import _ from 'lodash/fp';

const DATA_KEY = 'soil_analyses_data';

export const paramThresholds = {
  pH: (
    <ul className='list-group list-group-flush'>
      <li className='list-group-item'>Adecuado: 6.2 – 7.3</li>
      <li className='list-group-item'>Aceptable: 5.8–6.2 o 7.3–7.8</li>
      <li className='list-group-item'>Deficiente: &lt;5.8 o &gt;7.8</li>
    </ul>
  ),

  MO: (
    <ul className='list-group list-group-flush'>
      <li className='list-group-item'>Adecuado: ≥2.8</li>
      <li className='list-group-item'>Aceptable: 1.5–2.8</li>
      <li className='list-group-item'>Deficiente: &lt;1.5</li>
    </ul>
  ),

  CO: (
    <ul className='list-group list-group-flush'>
      <li className='list-group-item'>Adecuado: ≥1.5</li>
      <li className='list-group-item'>Aceptable: 0.5–1.5</li>
      <li className='list-group-item'>Deficiente: &lt;0.5</li>
    </ul>
  ),

  CE: (
    <ul className='list-group list-group-flush'>
      <li className='list-group-item'>Adecuado: &lt;2</li>
      <li className='list-group-item'>Aceptable: 2–4</li>
      <li className='list-group-item'>Deficiente: ≥4</li>
    </ul>
  ),

  Nt: (
    <ul className='list-group list-group-flush'>
      <li className='list-group-item'>Adecuado: ≥0.160</li>
      <li className='list-group-item'>Aceptable: 0.125–0.160</li>
      <li className='list-group-item'>Deficiente: &lt;0.125</li>
    </ul>
  ),

  RelatCN: (
    <ul className='list-group list-group-flush'>
      <li className='list-group-item'>Adecuado: ≥12</li>
      <li className='list-group-item'>Aceptable: 10–12</li>
      <li className='list-group-item'>Deficiente: &lt;10</li>
    </ul>
  ),

  NO3: (
    <ul className='list-group list-group-flush'>
      <li className='list-group-item'>Adecuado: ≥80</li>
      <li className='list-group-item'>Aceptable: 53–80</li>
      <li className='list-group-item'>Deficiente: &lt;53</li>
    </ul>
  ),

  N_NO3: (
    <ul className='list-group list-group-flush'>
      <li className='list-group-item'>Adecuado: ≥18</li>
      <li className='list-group-item'>Aceptable: 12–18</li>
      <li className='list-group-item'>Deficiente: &lt;12</li>
    </ul>
  ),

  P: (
    <ul className='list-group list-group-flush'>
      <li className='list-group-item'>Adecuado: ≥22</li>
      <li className='list-group-item'>Aceptable: 10–22</li>
      <li className='list-group-item'>Deficiente: &lt;10</li>
    </ul>
  ),

  K: (
    <ul className='list-group list-group-flush'>
      <li className='list-group-item'>Adecuado: ≥300</li>
      <li className='list-group-item'>Aceptable: 201–300</li>
      <li className='list-group-item'>Deficiente: ≤201</li>
    </ul>
  ),

  KCIC: (
    <ul className='list-group list-group-flush'>
      <li className='list-group-item'>Adecuado: ≥0.77</li>
      <li className='list-group-item'>Aceptable: 0.51–0.77</li>
      <li className='list-group-item'>Deficiente: ≤0.51</li>
    </ul>
  ),

  Ca: (
    <ul className='list-group list-group-flush'>
      <li className='list-group-item'>Adecuado: ≥1600</li>
      <li className='list-group-item'>Aceptable: 800–1600</li>
      <li className='list-group-item'>Deficiente: ≤800</li>
    </ul>
  ),

  CaCIC: (
    <ul className='list-group list-group-flush'>
      <li className='list-group-item'>Adecuado: ≥8</li>
      <li className='list-group-item'>Aceptable: 4–8</li>
      <li className='list-group-item'>Deficiente: ≤4</li>
    </ul>
  ),

  Mg: (
    <ul className='list-group list-group-flush'>
      <li className='list-group-item'>Adecuado: ≥120</li>
      <li className='list-group-item'>Aceptable: 60–120</li>
      <li className='list-group-item'>Deficiente: ≤60</li>
    </ul>
  ),

  MgCIC: (
    <ul className='list-group list-group-flush'>
      <li className='list-group-item'>Adecuado: ≥1</li>
      <li className='list-group-item'>Aceptable: 0.5–1</li>
      <li className='list-group-item'>Deficiente: ≤0.5</li>
    </ul>
  ),

  S: (
    <ul className='list-group list-group-flush'>
      <li className='list-group-item'>Adecuado: ≥15</li>
      <li className='list-group-item'>Aceptable: 10–15</li>
      <li className='list-group-item'>Deficiente: &lt;10</li>
    </ul>
  ),

  Na: (
    <ul className='list-group list-group-flush'>
      <li className='list-group-item'>Adecuado: &lt;180</li>
      <li className='list-group-item'>Aceptable: 180–230</li>
      <li className='list-group-item'>Deficiente: ≥230</li>
    </ul>
  ),

  NaCIC: (
    <ul className='list-group list-group-flush'>
      <li className='list-group-item'>Adecuado: &lt;0.78</li>
      <li className='list-group-item'>Aceptable: 0.78–1</li>
      <li className='list-group-item'>Deficiente: ≥1</li>
    </ul>
  ),

  SaturacionBasesPorc: (
    <ul className='list-group list-group-flush'>
      <li className='list-group-item'>Adecuado: 70 – 80 %</li>
      <li className='list-group-item'>Aceptable: 60 – 70 % o 80 – 90 %</li>
      <li className='list-group-item'>Deficiente: &lt;60 % o &gt;90 %</li>
    </ul>
  ),

  SaturacionBases: (
    <ul className='list-group list-group-flush'>
      <li className='list-group-item'>
        Corresponde a la <b>Suma de Ca, Mg, K y Na</b> expresados en meq/100g de suelo.
      </li>
    </ul>
  ),

  CIC: (
    <div>
      <p className='fw-bold mb-2'>Depende de Clase Textural:</p>
      <ul className='list-group list-group-flush'>
        <li className='list-group-item'>Arcilloso: Adecuado ≥30 | Aceptable 20–30 | Deficiente &lt;20</li>
        <li className='list-group-item'>Franco arcilloso: Adecuado ≥18 | Aceptable 15–18 | Deficiente &lt;15</li>
        <li className='list-group-item'>Franco arcillo-limoso / limoso / franco: Adecuado ≥15 | Aceptable 12–15 | Deficiente &lt;12</li>
        <li className='list-group-item'>Franco arcillo-arenoso: Adecuado ≥10 | Aceptable 8–10 | Deficiente &lt;8</li>
        <li className='list-group-item'>Franco arenoso: Adecuado ≥6 | Aceptable 3–6 | Deficiente &lt;3</li>
        <li className='list-group-item'>Arenoso: Adecuado ≥3 | Aceptable 1.5–3 | Deficiente &lt;1.5</li>
      </ul>
    </div>
  )
};


export default function SoilAnalysesForm({ soil_analyses, setSoilAnalyses = () => {} }) {
  const changeHandler = (major, minor) => (ev) => {
    let inputValue = ev.target.value.replace(',', '.');

    setSoilAnalyses((prevState) => {
      let newData = _.set(`${DATA_KEY}.${major}.${minor}`, inputValue, prevState);

      const value = parseFloat(inputValue);

      if (!isNaN(value) && value >= 0) {
        // Inicializar campos relacionados
        const ensure = (key) => {
          if (!newData[DATA_KEY][key]) newData[DATA_KEY][key] = {};
        };
        ['K','KCIC','Ca','CaCIC','Mg','MgCIC','Na','NaCIC','NO3','N_NO3','MO','CO','Nt','RelatCN','SaturacionBases','SaturacionBasesPorc','CIC']
          .forEach(ensure);

        const v = value;
        // Conversiones ppm <-> meq
        if (major === 'Ca') newData[DATA_KEY]['CaCIC'][minor] = (v / 10 / 40 * 2).toFixed(2);
        if (major === 'CaCIC') newData[DATA_KEY]['Ca'][minor] = (v * 10 * 40 / 2).toFixed(2);

        if (major === 'K') newData[DATA_KEY]['KCIC'][minor] = (v / 10 / 39 * 1).toFixed(2);
        if (major === 'KCIC') newData[DATA_KEY]['K'][minor] = (v * 10 * 39 / 1).toFixed(2);

        if (major === 'Mg') newData[DATA_KEY]['MgCIC'][minor] = (v / 10 / 24 * 2).toFixed(2);
        if (major === 'MgCIC') newData[DATA_KEY]['Mg'][minor] = (v * 10 * 24 / 2).toFixed(2);

        if (major === 'Na') newData[DATA_KEY]['NaCIC'][minor] = (v / 10 / 23 * 1).toFixed(2);
        if (major === 'NaCIC') newData[DATA_KEY]['Na'][minor] = (v * 10 * 23 / 1).toFixed(2);

        if (major === 'NO3') newData[DATA_KEY]['N_NO3'][minor] = (v / 4.427).toFixed(2);
        if (major === 'N_NO3') newData[DATA_KEY]['NO3'][minor] = (v * 4.427).toFixed(2);

        if (major === 'CO') newData[DATA_KEY]['MO'][minor] = (v * 1.724).toFixed(2);
        if (major === 'MO') newData[DATA_KEY]['CO'][minor] = (v / 1.724).toFixed(2);

        // Relación C/N
        if (newData[DATA_KEY]['CO'][minor] && newData[DATA_KEY]['Nt'][minor]) {
          const coValue = parseFloat(newData[DATA_KEY]['CO'][minor]);
          const ntValue = parseFloat(newData[DATA_KEY]['Nt'][minor]);
          newData[DATA_KEY]['RelatCN'][minor] =
            ntValue && !isNaN(ntValue) ? (coValue / ntValue).toFixed(2) : undefined;
        } else {
          newData[DATA_KEY]['RelatCN'][minor] = undefined;
        }

        const ca = parseFloat(newData[DATA_KEY]['CaCIC'][minor]) || 0;
        const mg = parseFloat(newData[DATA_KEY]['MgCIC'][minor]) || 0;
        const na = parseFloat(newData[DATA_KEY]['NaCIC'][minor]) || 0;
        const k  = parseFloat(newData[DATA_KEY]['KCIC'][minor]) || 0;
        const cic = parseFloat(newData[DATA_KEY]['CIC'][minor]) || 0;

        const saturacionBases = ca + mg + na + k;
        newData[DATA_KEY]['SaturacionBases'][minor] = saturacionBases.toFixed(2);

        if (cic > 0) {
          newData[DATA_KEY]['SaturacionBasesPorc'][minor] = ((saturacionBases / cic) * 100).toFixed(2);
        } else {
          newData[DATA_KEY]['SaturacionBasesPorc'][minor] = undefined;
        }
      }

      return newData;
    });
  };

  const changeHandler2 = (key) => (ev) => {
    let inputValue = ev.target.value.replace(',', '.'); // siempre punto
    
    setSoilAnalyses((prevState) => {
      // guardamos el texto tal cual (con la coma ya convertida a punto)
      let newData = _.set(`${DATA_KEY}.${key}`, inputValue, prevState);

      return newData;
    });
  };

  const data = soil_analyses?.[DATA_KEY];

  const pop = (rowkey, name) => (
    <Popover id={`popover-${rowkey}`}>
      <Popover.Header as='h3'>
        {rowkey === 'SaturacionBases' ? `Información de ${name}` : `Umbrales de ${name}`}
      </Popover.Header>
      <Popover.Body>
        {paramThresholds[rowkey]}
      </Popover.Body>
    </Popover>
  );

  return (
    <Stack gap={3} className='my-3'>
      <div className='card-soft'>
        <Form.Group controlId='name' className='mb-3'>
          <Form.Label>Lote</Form.Label>
          <Form.Control
            type='text'
            name='name'
            required
            placeholder='Ingresá un nombre para identificar este análisis'
            value={soil_analyses?.name ?? ''}
            onChange={(ev) => setSoilAnalyses((prev) => ({ ...prev, name: ev.target.value }))}
          />
        </Form.Group>

        <Form.Group controlId='description' className='mb-3'>
          <Form.Label>Descripción</Form.Label>
          <Form.Control
            as='textarea'
            rows='3'
            name='description'
            placeholder='Notas, ambiente, muestreo, etc.'
            value={soil_analyses?.description ?? ''}
            onChange={(ev) => setSoilAnalyses((prev) => ({ ...prev, description: ev.target.value }))}
          />
        </Form.Group>
      </div>

      <div className='card-soft'>
        <div className='row g-3'>
          <div className='col-12 col-md-6'>
            <Form.Group controlId='nitrification'>
              <Form.Label>Nitrificación (%)</Form.Label>
              <Form.Control
                type='text'
                inputMode='decimal'
                value={data?.nitrification ?? ''}
                onWheel={(e) => e.target.blur()}
                onChange={(e) => {
                  const raw = e.target.value.replace(',', '.'); 
                  // permitir solo dígitos y UN solo punto
                  if (/^\d*\.?\d*$/.test(raw)) {
                    changeHandler2('nitrification')({ target: { value: raw } });
                  }
                }}
              />
              <div className='form-text'>
                Cultivos de Invierno: 1.5 — Maíz 1ra: 3.0 — Maíz tardío: 4.5
              </div>
            </Form.Group>
          </div>

          <div className='col-12 col-md-6'>
            <Form.Group controlId='mineralization'>
              <Form.Label>Mineralización (%)</Form.Label>
              <Form.Control
                type='text'
                inputMode='decimal'
                value={data?.mineralization ?? ''}
                onWheel={(e) => e.target.blur()}
                onChange={(e) => {
                  const raw = e.target.value.replace(',', '.');
                  if (/^\d*\.?\d*$/.test(raw)) {
                    changeHandler2('mineralization')({ target: { value: raw } });
                  }
                }}
              />
              <div className='form-text'>
                Cultivos de Invierno: 1.5 — Maíz 1ra: 3.0 — Maíz tardío: 4.5
              </div>
            </Form.Group>
          </div>
        </div>
      </div>

      <div className='card-soft mt-3 mb-4 table-responsive'>
        <Table bordered hover className='table-modern align-middle'>
          <thead>
            <tr>
              <th>Parámetros</th>
              {Object.entries(cols).map(([key, name]) => (
                <th key={key}>{name}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {Object.entries(rows).map(([rowkey, name]) => (
              <tr key={rowkey}>
                <td className='fw-semibold'>
                  {name}
                  {paramThresholds[rowkey] && (
                    <OverlayTrigger
                      trigger='click'
                      placement='right'
                      overlay={pop(rowkey, name)}
                      rootClose
                    >
                      <InfoCircle
                        className='ms-2 text-primary'
                        style={{ cursor: 'pointer' }}
                      />
                    </OverlayTrigger>
                  )}
                </td>
                {Object.keys(cols).map((colkey) => (
                  <td key={colkey} style={{ minWidth: 120 }}>
                    <Form.Control
                      type='text'
                      inputMode='decimal'
                      value={data?.[rowkey]?.[colkey] ?? ''}
                      onWheel={(e) => e.target.blur()}
                      onChange={(e) => {
                        const raw = e.target.value.replace(',', '.');
                        if (/^\d*\.?\d*$/.test(raw)) {
                          changeHandler(rowkey, colkey)({
                            target: { value: raw },
                          });
                        }
                      }}
                    />
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
    </Stack>
  );
}